import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { WalletCard } from '@kr/models';

import { GetUserIdsRes, GetUsersRes } from '../models';

export interface WalletUsersApi {
  getUsers(): Observable<GetUsersRes>;
  getUserIds(wallet: WalletCard): Observable<GetUserIdsRes>;
  addUsers(wallet: WalletCard, userIds: number[]): Observable<void>;
  removeUsers(wallet: WalletCard, userIds: number[]): Observable<void>;
}

export const WALLET_USERS_API = new InjectionToken<WalletUsersApi>('WALLET_USERS_API');
